export default __webpack_public_path__ + "static/media/mobile.76834d3d.jpg";